
import CrossIcon from "../svg/cross"
import MinusIcon from "../svg/minus"

export default function TicketQuantityButtons(props) {

    return (
        <div className="ticket-quantity-buttons">
            <div className='ticket-quantity-buttons__counter' role="region" aria-live="assertive">{props.ticketQuantity}</div>
            <button className='btn btn--square ticket-quantity-buttons__increment'
                    type="button"
                    disabled={props.maxTickets ? props.ticketQuantity >= props.maxTickets : false}
                    onClick={() => props.setTicketQuantity((prev) => prev + 1)}>
                <span className='sr-text'>Increase ticket quantity</span>
                <CrossIcon />
            </button>
            <button className='btn btn--square ticket-quantity-buttons__decrement' 
                    type="button" 
                    disabled={props.ticketQuantity <= 1} 
                    onClick={() => props.setTicketQuantity((prev) => prev - 1)}>
                <span className='sr-text'>Decrease ticket quantity</span>
                <MinusIcon />
            </button>
        </div>
    );
}